/**
 * @generated SignedSource<<c6ed5cd1b7e4a57c0234a7709c1d5948>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges$data = ReadonlyArray<{
  readonly node: {
    readonly versionId: string;
    readonly " $fragmentSpreads": FragmentRefs<"moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion">;
  };
  readonly " $fragmentType": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges";
} | null | undefined>;
export type versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges$key = ReadonlyArray<{
  readonly " $data"?: versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersion",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "versionId"
            },
            "action": "NONE",
            "path": "node.versionId"
          },
          {
            "kind": "FragmentSpread",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
          }
        ]
      },
      "action": "NONE",
      "path": "node"
    }
  ],
  "type": "JiraVersionEdge"
};

(node as any).hash = "62c56f9fefcd51f7cc6feffc9b24ce64";

export default node;
